import React from 'react';

import { Button } from '../../../../design-system';
import DiscussLineIcon from '../../../../design-system/Icons/DiscussLineIcon';

const FeedbackSection = () => {
    return (
        <div className="flex flex-col gap-5">
            <div className="px-2 pt-2 pb-[40px] border-b-1 border-neutral-200">
                <p className="font-body text-body-regular-s text-neutral-500">
                    No feedback submitted yet.
                </p>
            </div>

            <div className="flex justify-center">
                <Button type="link" size="xs" text="Share Feedback" leadingIcon={DiscussLineIcon} />
            </div>
        </div>
    );
};

export default FeedbackSection;
